import type { LeDataProvenance } from '~/types/leData';

import { CONFIDENCE_BUCKET_LABEL, type LeDataConfidenceBucket, getConfidenceBucket } from '~/utils/leData/provenance';

export const RECEIPT_CTA_WITH_FACTS = 'See how';
export const RECEIPT_CTA_ALONE = 'How I got this';
export const LOW_CONFIDENCE_CAVEAT = 'Confidence is low here. Worth checking with an analyst.';

export interface ReceiptFacts {
  facts: Array<string>;
  tablesTitle?: string;
  confidence: LeDataConfidenceBucket | null;
}

const RECEIPT_SOURCES = 3;

function sourceName(fqn: string): string {
  return fqn.replace(/`/g, '').split('.').slice(-2).join('.');
}

export function receiptFacts(provenance: LeDataProvenance | undefined): ReceiptFacts {
  if (!provenance) {
    return { facts: [], confidence: null };
  }
  const facts: Array<string> = [];
  const sources = provenance.tables.map((table) => sourceName(table.fqn));
  if (sources.length > 0) {
    const more = sources.length > RECEIPT_SOURCES ? ` +${sources.length - RECEIPT_SOURCES}` : '';
    facts.push(`Sources: ${sources.slice(0, RECEIPT_SOURCES).join(', ')}${more}`);
  }
  const verified = provenance.terms.filter((term) => term.verified).length;
  if (verified > 0) {
    facts.push(`${verified} verified ${verified === 1 ? 'definition' : 'definitions'}`);
  }
  const confidence = getConfidenceBucket(provenance.confidence);
  if (confidence) {
    facts.push(`${CONFIDENCE_BUCKET_LABEL[confidence]} confidence`);
  }
  return {
    facts,
    confidence,
    tablesTitle: provenance.tables.length > 0 ? provenance.tables.map((table) => table.fqn).join('\n') : undefined,
  };
}

export function receiptCta(facts: ReadonlyArray<string>): string {
  return facts.length > 0 ? RECEIPT_CTA_WITH_FACTS : RECEIPT_CTA_ALONE;
}
